import { render, staticRenderFns } from "./downstreamAnalysis.vue?vue&type=template&id=5f289098&scoped=true&"
import script from "./downstreamAnalysis.vue?vue&type=script&lang=js&"
export * from "./downstreamAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./downstreamAnalysis.vue?vue&type=style&index=0&id=5f289098&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f289098",
  null
  
)

export default component.exports